import * as React from "react";

interface TeacherPreviewMenuButtonProps {
  containerClass?: string,
  onTogglePreview: () => void
}

export const TeacherPreviewMenuButton = ({ containerClass, onTogglePreview }: TeacherPreviewMenuButtonProps) => {
  return(
    <div className={containerClass}>
      <button className="quill-button medium outlined green focus-on-dark" id="teacher-preview-menu-button" onClick={onTogglePreview} type="button">Show menu</button>
    </div>
  );
}

export default TeacherPreviewMenuButton;
